import React, { useState } from "react";
import style from "./CommentForm.module.css";
function CommentForm() {
  const form = {
    message: "",
    name: "",
    email: "",
  };

  const [commentForm, setcommentForm] = useState(form);
  return (
    <form className={style.form}>
      <span className={style.heading}>
        Your email address will not be published. Required fields are marked *
      </span>
      <textarea
        value={commentForm.message}
        className={style.textArea}
        placeholder="Write a comment..."
        onChange={e =>
          setcommentForm({ ...commentForm, message: e.target.value })
        }
      />
      <label>Name *</label>
      <input
        type="text"
        className={style.input}
        value={commentForm.name}
        onChange={e => setcommentForm({ ...commentForm, name: e.target.value })}
      />
      <label>Email *</label>
      <input
        type="email"
        className={style.input}
        value={commentForm.email}
        onChange={e =>
          setcommentForm({ ...commentForm, email: e.target.value })
        }
      />
      <button type="submit" className={style.submitBtn}>
        Post Comment
      </button>
    </form>
  );
}

export default CommentForm;
